// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__h0ZR+","visible":"overlay_visible__28O+i","dark":"overlay_dark__DI-XI","transparent":"overlay_transparent__FBkLA"};